import { Box } from '@chakra-ui/react'

import { NotificationsTab } from '@/features/notifications-tab'

import { Drawers } from './Drawers'
import { SideBar } from './SideBar'

interface PageLayoutIProps {
  children?: React.ReactNode
}

export const PageLayout = ({ children }: PageLayoutIProps) => {
  return (
    <>
      <Box bgColor='bg.100' h='full'>
        <Box display='flex' h='full' minH={0}>
          <SideBar />
          <Box flex={1} minW={0} pos='relative'>
            {children}
          </Box>
        </Box>
      </Box>
      <NotificationsTab />
      <Drawers />
    </>
  )
}
